import React from 'react';
import "../../styles/collections/add_collection.css";
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { firebaseAuth, firebaseFirestore } from "../firebase/firebase_configuration";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";

const AddCollection = ({getShow, setShow}) => {
    const [getUserId, setUserId] = useState("");
    const [getCollectionName, setCollectionName] = useState("");
    const [getCollectionDescription, setCollectionDescription] = useState("");
    const [getCollectionPrivacy, setCollectionPrivacy] = useState("public");

    const onChangeCollectionName = (name) => {
        setCollectionName(name.target.value);
    };

    const onChangeCollectionDescription = (description) => {
        setCollectionDescription(description.target.value);
    };

    const onSetCollectionPrivacy = (privacy) => {
        setCollectionPrivacy(privacy.target.value);
    };

    const onCreateCollection = async () => {
        if (getCollectionName.length < 5) {
            alert("Collection name should be at least 5 character.");
        } else {
            const collectionDetails = {
                name: getCollectionName,
                description: getCollectionDescription,
                privacy: getCollectionPrivacy,
                items: [],
            };

            try {
                const userRef = doc(firebaseFirestore, 'User Collections', getUserId);
                const docSnapshot = await getDoc(userRef);
                if (docSnapshot.exists()) {
                    await updateDoc(userRef, {
                        [`collection${Date.now().toString()}`]: collectionDetails,
                    });
                }else{
                    await setDoc(userRef, {
                        [`collection${Date.now().toString()}`]: collectionDetails,
                    });
                }  
            } catch (error) {
                alert("Failed to save collection details. Please try again.");
                console.log(error.message); 
            }

            setShow(false);
        }
    }

    useEffect(() => {
        onAuthStateChanged(firebaseAuth, (user) => {
            if (user) {
                setUserId(user.uid);
            }
        });
    }, []);

    return(
        <div className={`view_add_collection ${getShow ? "show" : ""}`}>
            <div className="view_add_collection_overlay" onClick={() => setShow(false)}></div>
            <div className="view_add_collection_content">
                <p className="view_add_collection_content_header">Create a Collection</p>
                <p className="view_add_collection_input_label">Collection Name</p>
                <div className="view_add_collection_input_con">
                    <input className="view_add_collection_input" placeholder="Enter a name for this collection" type="text" maxLength={50} value={getCollectionName} onChange={onChangeCollectionName} />
                </div>

                <p className="view_add_collection_input_label">Collection Description</p>
                <div className="view_add_collection_input_con">
                    <input className="view_add_collection_input" placeholder="Enter a description for this collection" type="text" maxLength={200} value={getCollectionDescription} onChange={onChangeCollectionDescription} />
                </div>

                <div class="privacy_radio-group">
                    <label>
                        <input type="radio" name="privacy_option" value="public" checked={getCollectionPrivacy === "public"} onChange={onSetCollectionPrivacy} /> Public
                    </label>
                    <label>
                        <input type="radio" name="privacy_option" value="private" checked={getCollectionPrivacy === "private"} onChange={onSetCollectionPrivacy} /> Private
                    </label>
                </div>

                <div className="view_add_collection_button" onClick={() => onCreateCollection()}>
                    Add Collection
                </div>
            </div>
        </div>
    );
};

export default AddCollection;